<template>
  <section class="section__equipo">
    <h1 class="section__equipo-title">EQUIPO</h1>
    <p class="section__equipo-text">
      Nos convertimos en una extensa familia de diferentes sectores geográficos
      con alta variedad cultural,<br/> lo que enriquece nuestra creatividad y le
      brinda color a nuestros proyectos.
    </p>
    <div class="team--slider" id="team--slider">
      <div class="team--slider__container">
        <font-awesome-icon
          :icon="['far', 'angle-right']"
          size="3x"
          class="team--slider__arrow right"
          @click="next"
          v-if="!limitRight"
        />
        <font-awesome-icon
          :icon="['far', 'angle-left']"
          size="3x"
          class="team--slider__arrow left"
          @click="prev"
          v-if="count > 0"
        />
        <div class="team--slider__slide" :style="slideStyles">
          <div
            class="profile"
            v-for="profile in teamProfiles"
            :key="profile.id"
            :style="bgImg(profile.img)"
          >
            <div class="content" v-if="profile.name">
              <p class="name">{{ profile.name }}</p>
              <div class="line"></div>
              <p class="area">{{ profile.area }}</p>
            </div>
          </div>
          <!-- <div
            class="profile"
            :style="bgImg('/img/png/SpareProfile.png')"
            v-if="Math.abs(teamProfiles.length % 2)"
          ></div> -->
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import mixins from "@/mixins/mixins";

export default {
  created() {
    this.windowWidth = window.innerWidth;
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
      this.count = 0;
      this.limitRight = false;
    });
  },
  mounted() {
    this.$store.commit("setScrolling", false);
  },
  data() {
    return {
      windowWidth: 0,
      count: 0,
      limitRight: false,
    };
  },
  computed: {
    teamProfiles() {
      const array = this.$store.state.teamProfiles;
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      let arrayCompleto = [...array];
      let falta = 0;
      if (this.windowWidth < 650 && array.length % 9 != 0) {
        falta = 9 - (array.length % 9);
      }

      if (
        this.windowWidth >= 650 &&
        this.windowWidth < 1100 &&
        array.length % 6 != 0
      ) {
        falta = 6 - (array.length % 6);
      }

      if (this.windowWidth > 1100 && array.length % 12 != 0) {
        falta = 12 - (array.length % 12);
      }

      if (falta) {
        for (let index = 0; index < falta; index++) {
          arrayCompleto.push({
            id: array.lengh,
            name: "",
            area: "",
            img: "/img/png/SpareProfile.jpg",
          });
        }
        return arrayCompleto;
      }
      return array;
    },
    slideStyles() {
      if (this.windowWidth < 520) {
        return `transform: translateX(calc(-100% * ${this.count}))`;
      } else {
        return `transform: translateX(calc(-100% * ${this.count}))`;
      }
    },
    nextVar() {
      return this.$store.state.team.nextVar;
    },
    prevVar() {
      return this.$store.state.team.prevVar;
    },
  },
  methods: {
    next() {
      let limit = 0;

      if (this.windowWidth < 650) {
        limit = Math.ceil(this.teamProfiles.length / 9 - 1);
      } else if (this.windowWidth > 650 && this.windowWidth < 1100) {
        limit = Math.ceil(this.teamProfiles.length / 6 - 1);
      } else {
        limit = Math.ceil(this.teamProfiles.length / 12 - 1);
      }

      if (this.count !== limit) {
        this.count++;
      }

      if (this.count === limit) {
        this.limitRight = true;
      }
    },
    prev() {
      if (this.count !== 0) {
        this.count--;
        this.limitRight = false;
      }
    },
  },
  watch: {
    nextVar: function () {
      this.next();
    },
    prevVar: function () {
      this.prev();
    },
  },
  mixins: [mixins],
};
</script>
